import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-patient-mod-review',
  templateUrl: './patient-mod-review.component.html',
  styleUrls: ['./patient-mod-review.component.scss'],
})
export class PatientModReviewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PatientModReviewComponent>,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
